import React from 'react';
import SubPage from '../SubPage';
import Board from '../Board';
import { useLang } from '../../LanguageContext';

const CRUMB = { ko: '소식 자료', en: 'News' };
const T = {
  title: { ko: '보도 자료', en: 'Press' },
  lede:  { ko: '메디로지스의 최신 소식을 확인해 보세요.', en: 'The latest from MEDILOGIS.' },
  tag:   { ko: '보도자료', en: 'Press' },
};

function Press() {
  const { lang } = useLang();
  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      {/* 44건 중 41건은 기사 링크가 VIDEO_URL 이 아니라 본문 HTML 안에 있다.
          VIDEO_URL 있는 3건만 외부로 튀면 동작이 들쭉날쭉해지므로,
          전부 사이트 안에서 본문을 열고 원문 링크는 본문에서 누르게 한다. */}
      <Board category="PRESS" tag={T.tag} />
    </SubPage>
  );
}

export default Press;
